<template>
  <v-card class="pa-4 elevation-2 " outlined>
    <v-card-title>Slide Details</v-card-title>

    <v-card-text class="text-left ">
      <v-list dense>
        <v-list-item>
          <v-row class="w-100">
            <v-col cols="3">
              <v-list-item-title class="font-weight-bold">Frame Number:</v-list-item-title>
            </v-col>
            <v-col cols="9">{{ frame.number }}</v-col>
          </v-row>
        </v-list-item>

        <v-list-item>
          <v-row class="w-100">
            <v-col cols="3">
              <v-list-item-title class="font-weight-bold">Latex:</v-list-item-title>
            </v-col>
            <v-col cols="9">{{ frame.content }}</v-col>
          </v-row>
        </v-list-item>

        <v-list-item>
          <v-row class="w-100">
            <v-col cols="3">
              <v-list-item-title class="font-weight-bold">Is External:</v-list-item-title>
            </v-col>
            <v-col cols="9">{{ frame.isExternal }}</v-col>
          </v-row>
        </v-list-item>

        <v-list-item v-if="frame.externalFile">
          <v-row class="w-100">
            <v-col cols="3">
              <v-list-item-title class="font-weight-bold">External File:</v-list-item-title>
            </v-col>
            <v-col cols="9">{{ frame.externalFile }}</v-col>
          </v-row>
        </v-list-item>

        <v-list-item v-if="frame.isReplaced">
          <v-row class="w-100">
            <v-col cols="3">
              <v-list-item-title class="font-weight-bold">Replaced:</v-list-item-title>
            </v-col>
            <v-col cols="9">{{ frame.isReplaced }}</v-col>
          </v-row>
        </v-list-item>

        <v-list-item v-if="frame.isGenerated">
          <v-row class="w-100">
            <v-col cols="3">
              <v-list-item-title class="font-weight-bold">Generated:</v-list-item-title>
            </v-col>
            <v-col cols="9">{{ frame.isGenerated }}</v-col>
          </v-row>
        </v-list-item>

        <v-expansion-panels class="pa-1 w-100" v-if="frame.selectedSlideTemplate" multiple>
          <v-expansion-panel class="elevation-1" outlined>
            <v-expansion-panel-title class="font-weight-bold">
              Selected Slide Template — {{ frame.selectedSlideTemplate.title || 'No title' }}
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-list dense>
                <v-list-item>
                  <v-row class="w-100">
                    <v-col cols="4">
                      <v-list-item-title class="font-weight-bold">Title:</v-list-item-title>
                    </v-col>
                    <v-col cols="8">{{ frame.selectedSlideTemplate.title }}</v-col>
                  </v-row>
                </v-list-item>

                <v-list-item>
                  <v-row class="w-100">
                    <v-col cols="4">
                      <v-list-item-title class="font-weight-bold">Packages:</v-list-item-title>
                    </v-col>
                    <v-col cols="8">{{ Array.from(frame.selectedSlideTemplate.dependenciesPkg).join(', ') || 'None' }}</v-col>
                  </v-row>
                </v-list-item>

                <v-list-item>
                  <v-row class="w-100">
                    <v-col cols="4">
                      <v-list-item-title class="font-weight-bold">TikZ:</v-list-item-title>
                    </v-col>
                    <v-col cols="8">{{ Array.from(frame.selectedSlideTemplate.dependenciesTikz).join(', ') || 'None' }}</v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row class="w-100">
                    <v-col cols="4">
                      <v-list-item-title class="font-weight-bold">Generated Content:</v-list-item-title>
                    </v-col>
                    <v-col cols="8">{{ frame.selectedSlideTemplate.generatedContend }}</v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-list>

      <v-divider class="my-2" v-if="frame.template" />

      <p class="ma-2 text-left font-weight-medium">
          Die vorgeschlagene Folien: {{ frame.template ? 'vorhanden' : 'noch nicht generiert' }}
      </p>

      <v-expansion-panels v-if="frame.template" multiple>
        <v-expansion-panel
          v-for="(slide, index) in frame.template.slideTemplate"
          :key="index"
        >
          <v-expansion-panel-title>
            Template of Slide {{ index }} — {{ slide.title || 'No title' }}
            <v-chip
              :color="getScoreColor(slide.score)" 
              class="ml-3 pl-2"
              label
              small
            >
              Score: {{ slide.score === 1 ? '1.0' : slide.score }}
            </v-chip>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <v-list dense>
              <v-list-item>
                <v-row class="w-100">
                  <v-col cols="4">
                    <v-list-item-title class="font-weight-bold">Packages:</v-list-item-title>
                  </v-col>
                  <v-col cols="8">
                    {{ Array.from(slide.dependenciesPkg).join(', ') || 'None' }}
                  </v-col>
                </v-row>
              </v-list-item>

              <v-list-item>
                <v-row class="w-100">
                  <v-col cols="4">
                    <v-list-item-title class="font-weight-bold">TikZ:</v-list-item-title>
                  </v-col>
                  <v-col cols="8">
                    {{ Array.from(slide.dependenciesTikz).join(', ') || 'None' }}
                  </v-col>
                </v-row>
              </v-list-item>

              <v-list-item v-if="slide.generatedContend">
                <v-row class="w-100">
                  <v-col cols="4">
                    <v-list-item-title class="font-weight-bold">Generated Content:</v-list-item-title>
                  </v-col>
                  <v-col cols="8">{{ slide.generatedContend }}</v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { Frame } from '@/types/frame';

export default defineComponent({
  name: 'PresentationLayoutStudioComponenten',
  props: {
    frame: {
      type: Object as () => Frame,
      required: true,
    },
  },
  methods: {
    getScoreColor(score: number | undefined | null): string {
      if (score === undefined || score === null) {
        return 'primary';
      } else if (score < 0.6) {
        return 'red-darken-3';
      } else if (score < 0.92) {
        return 'orange-darken-3';
      } else {
        return 'green-darken-2';
      }
    },
  },
});
</script>
